// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IdcardFilledSvg from "@ant-design/icons-svg/es/asn/IdcardFilled";
import AntdIcon from '../components/AntdIcon';

var IdcardFilled = function IdcardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: IdcardFilledSvg
  }));
};

IdcardFilled.displayName = 'IdcardFilled';
export default React.forwardRef(IdcardFilled);